import type { AccountSummary, HolisticCategory } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';
import { useRefetchHolisticSummaryMutationOptions } from '../useRefetchHolisticSummaryMutationOptions';

interface UpsertSpinwheelLoanAccountBody {
    id?: string;
    displayName?: string;
    userId?: string;
    holisticCategory?: HolisticCategory;
    minimumPaymentAmountCents?: number;
    interestRate?: number | null;
    description?: string;
    isHidden?: boolean;
}

const useUpsertSpinwheelLoanAccount = requestBuilder.mutation<
    AccountSummary,
    UpsertSpinwheelLoanAccountBody
>({
    endpoint: '/api/admin/holistic/accounts/spinwheel/loan',
    method: 'PATCH',
});

export const useUpsertSpinwheelLoanAccountAndRefetch = (
    membershipId: string | null,
) => {
    const refetchHolisticSummaryMutationOptions =
        useRefetchHolisticSummaryMutationOptions(membershipId);

    const { mutateAsync } = useUpsertSpinwheelLoanAccount(
        refetchHolisticSummaryMutationOptions,
    );

    const upsertSpinwheelLoanAccountAsync = async (
        body: UpsertSpinwheelLoanAccountBody,
    ) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        upsertSpinwheelLoanAccountAsync,
    };
};
